import React, { Component } from 'react';
import GoogleMap from './GoogleMap';

const Marker = ({ text }) => (
    <i className="is-marker">
        <svg viewBox="0 0 22 22" width="100%" height="100%"><path fill="#74AEBB" d="M18 2c1.1 0 2 0.9 2 2l0 13c0 1.1-0.9 2-2 2l-4 0 -3 3 -3-3 -4 0c-1.1 0-2-0.9-2-2l0-13c0-1.1 0.9-2 2-2l14 0Zm-7 10.9l2.8 1.7 -0.7-3.2 2.5-2.1 -3.2-0.3 -1.3-3 -1.3 3 -3.2 0.3 2.5 2.1 -0.7 3.2 2.8-1.7Z"></path></svg>
    </i>
);

const conditionalListItemRender = (item) => {
    if (item) {
        return <li><h5>{item}</h5></li>
    }
    return null;
}

export default ({ location, styles, apiKey, locale }) => {
    const { title, addressLine1, addressLine2, addressLine3 } = location;
    const { latitude, longitude } = location.location;
    return <div className="is-location-with-map">
        <GoogleMap
            lang={locale}
            apiKey={apiKey}
            style={{ width: `100%`, height: `200px` }}
            defaultCenter={[latitude, longitude]}
            defaultZoom={13.0}
            markers={[{ lat: latitude, lng: longitude }]}
            options={{
                minZoomOverride: true,
                minZoom: 2,
                fullscreenControl: false,
                styles
            }}
        >
            <Marker
                lat={latitude}
                lng={longitude}
            />
        </GoogleMap>
        <div className="is-map-info">
            <h2 className="has-text-weight-condensed">{title}</h2>
            <ul className="has-text-weight-medium">
                {conditionalListItemRender(addressLine1)}
                {conditionalListItemRender(addressLine2)}
                {conditionalListItemRender(addressLine3)}
            </ul>
        </div>
    </div>
};


// WEBPACK FOOTER //
// ./src/components/LocationWithMap.js